import { Customer, OnSaveCustomer } from "#/pages";

import { useApi } from "@/api";
import { useCallback } from "react";
import { useNavigate } from 'react-router-dom';

const CustomerView = () => {
  const { customer } = useApi();
  const navigate = useNavigate();

  const handleSave: OnSaveCustomer = useCallback(async (
    newCustomer,
    newAddress,
    newContact,
    sendEmailNotification
  ) => {
    try
    {
      const success = await customer.createCustomer({
        accountDetails: {
          accountPhoneNumber: newCustomer.phone,
          accountType: '0',
          branchName: newCustomer.branchName,
          confirmPassword: newCustomer.confirmPassword,
          email: newCustomer.email,
          firstName: newCustomer.firstName,
          isActive: true,
          lastName: newCustomer.lastName,
          password: newCustomer.password,
          sendEmailNotification,
          website: newCustomer.website
        },
        address: {
          active: newCustomer.active,
          area: newAddress.area,
          countryId: newAddress.countryId,
          county: newAddress.county,
          customerCode: newCustomer.code,
          houseName: newAddress.houseName,
          houseNumber: newAddress.houseNumber,
          isCardPayment: newAddress.isCardPayment,
          isLowQuality: newAddress.isLowQuality,
          name: newCustomer.companyName,
          postcode: newAddress.postcode,
          road: newAddress.road,
          shouldRemoveData: newAddress.shouldRemoveData,
          tax: newAddress.vat,
          town: newAddress.town,
        },
        contacts: [{
          contactId: '',
          customerId: '',
          email: newContact.email,
          name: newContact.name,
          phone1: newContact.phone1,
          phone2: newContact.phone2 || '',
          sendInvoice: newContact.sendInvoice,
        }],
      });
      
    if (success)
      navigate('/customer-find');
  }
  catch (error) {
    console.error('Error creating customer:', error);
  }
    
  }, []);

  return (
    <>
      <Customer onSave={handleSave} />
    </>
  );
}

export default CustomerView;